<template>
  <div class="grid-container full">
    <div class="grid-x readyBox">
      <div class=" small-12 cell text-center">
        <div class="grid-x">
          <div class="small-12 cell">
            <h2>Ready?</h2>
          </div>
        </div>

          <div class="grid-x">
            <div class="small-12 cell text-center">
              <p>Great. Our team will assess your application and, if we think we can help you, we’ll invite you to join Rare.</p>
            </div>
          </div>

        <div class="grid-x">
          <div class="small-12 cell">
          <rare-standard-button
            class="contactButton show-for-small-only"
            :tabIndex="80"
            :active="'true'"
            :buttonText="'Apply now'"
            :height="'40px'"
            :fontColor="'#ffffff'"
            :fontSize="'12px'"
            @clicked="applyNow"
          />
            <rare-standard-button
              class="contactButton show-for-medium"
              :tabIndex="80"
              :buttonText="'Apply now'"
              :height="'64px'"
              :width="'282px'"
              :fontColor="'#ffffff'"
              :fontSize="'16px'"
              @clicked="applyNow"
            />

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RareStandardButton from '@/components/atoms/RareWebButton';


export default {
  name: 'RareCandidatesReady',
  components: {
    'rare-standard-button': RareStandardButton,
  },
  methods: {
    openContactForm() {
      this.$root.$emit('updateContactForm', true);
    },
    applyNow() {
      this.$router.push('/candidates/apply-now');
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  h2
  {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
    text-transform: uppercase;
  }

  p {
    color: #ffffff;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    //height: 40px;
  }

  @media only screen and (max-width: 640px)  {
    .readyBox {
      height: 315px;
      background-image: url("../../../assets/img/backgrounds/want-to-know-more.jpg");
      background-position: center;
    }

    h2 {
       font-size: 24px;
       line-height: 1.33;
       letter-spacing: 3px;
       margin: 40px 0 16px 0;
     }

    p {
      font-size: 16px;
    }

    .contactButton {
      margin: 20px auto 0 auto;
    }
  }

  @media only screen and (min-width: 641px)  {
    .readyBox {
      height: 360px;
      background-image: url("../../../assets/img/backgrounds/want-to-know-more.jpg");
    }

    h2 {
      font-size: 48px;
      line-height: 0.83;
      letter-spacing: 8px;
      margin: 80px 0 24px 0;
    }

    p {
      font-size: 24px;
    }

    .contactButton {
      margin: 12px auto 80px auto;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/candidates/components/RareCandidatesReady.vue